export function loader() {
    const spinner = document.getElementById('loading');
    spinner.classList.add('loaded');
    setTimeout(timerClassAdd, 5000);
    setTimeout(timerRemove, 10000);
    function timerClassAdd() {
        spinner.classList.add('loaded');
    }
    function timerRemove(){
        spinner.remove();
    }
}